<template>
    <v-layout row justify-center>
        <v-dialog v-model="openDialog" max-width="600px">
            <v-card>
                <v-card-text>
                    <v-container grid-list-md class="feedback-container">
                        <h2 class="feedback-title">Нет времени заполнять заявку?</h2>
                        <p class="feedback-subtitle">Оставьте номер телефона, мы перезвоним и сообщим<br>стоимость.</p>
                        <v-layout wrap v-if="!success">
                            <v-flex xs12>
                                <v-text-field
                                    v-model="phone"
                                    mask="+7 ### ### ## ##"
                                    label="Телефон"
                                />
                            </v-flex>
                        </v-layout>
                        <v-layout wrap>
                            <v-flex v-if="noData" class="feedback-info feedback-no-data">Ни одно поле не заполнено</v-flex>
                            <v-flex v-if="error" class="feedback-info feedback-no-data">Произошла ошибка при отправке, попробуйте позже</v-flex>
                            <v-flex v-if="success" class="feedback-info feedback-success">Спасибо! Данные успешно отправлены.</v-flex>
                        </v-layout>
                        <v-btn
                            v-if="!success"
                            class="button next-button block"
                            @click="sendData"
                        >
                            Заполните анкету за меня
                        </v-btn>
                        <p>
                            Вы соглашаетесь с <a :href="'https://getpolis.ru/osago_policy'" target="_blank">Политикой обработки персональных данных.</a>
                        </p>
                    </v-container>
                </v-card-text>
            </v-card>
        </v-dialog>
    </v-layout>
</template>
<script>
export default {
    name: "FormOutPopup",
    props: ['dialog'],

    data: () => ({
        openDialog: false,
        name: null,
        email: null,
        phone: null,
        message: null,
        success: false,
        noData: false,
        error: false
    }),

    watch: {
        dialog(value) {
            if (value) {
                this.openDialog = true
                this.$emit('closeFeedback')
            }
        }
    },

    methods: {
        sendData() {
            if (this.name == null && this.email == null && this.phone == null && this.message == null) {
                this.noData = true
                return
            }
            axios.post('/feedback', {
                'name' : this.name,
                'email' : this.email,
                'phone' : this.phone,
                'message' : this.message,
            })
                .then(response => {
                    this.noData = false
                    this.error = false
                    this.success = true
                })
                .catch(error => {
                    this.noData = false
                    this.error = true
                    console.log(error)
                })
        }

    }
}
</script>
<style scoped>
.button {
    line-height: 1.45 !important;
    font-weight: 700 !important;
    font-size: 16px !important;
    text-transform: none !important;
    box-shadow: none !important;

    width: 100%;
    height: 54px;
    text-align: center;
    display: table-cell;
    vertical-align: middle;
    padding: 0 !important;
    margin: 10px 20px 0 0;

    border-width: 1px;
    border-radius: 30px;
    border-style: solid;
}

.button >>> .v-btn__content {
    white-space: normal;
    line-height: 1.1;
}

.next-button {
    color: #ffffff !important;
    background-color: #00ba57 !important;
    border-color: transparent;
}
.feedback-title{
    font-family: 'SFUIDisplay';
    font-weight: 700;
    font-size: 36px;
    line-height: 1.23;
    margin-bottom: 11px;
    text-align: left;
}

.feedback-subtitle{
    font-family: 'SFUIDisplay';
    font-size: 16px;
    font-weight: 300;
    line-height: 1.55;
    text-align: left;
    margin: 0;
}

.feedback-info{
    width: 100%;
    padding: 20px;
    text-align: center;
    font-family: 'SFUIDisplay',Arial,sans-serif;
    color: #fff;
    font-size: 20px;
    line-height: 1.55;
    height: 70px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 10px 0 20px;
}
.feedback-no-data{
    background-color: #F95D51;
}
.feedback-success{
    background-color: #62C584;
}

.feedback-container {
    padding: 40px 45px;
}

.feedback-container .theme--light.v-text-field > .v-input__control > .v-input__slot:before{
    height: 1px;
    background-color: #ccc;
}
.feedback-container .v-input input{
    background-color: #ffffff;
}
.feedback-container textarea{
    padding: 25px 15px 0px;
}

.feedback-container a{
    text-decoration: underline;
    color: rgb(0, 166, 42)
}
.feedback-container a:hover{
    color: rgb(0, 166, 42)
}

@media (max-width: 600px) {
    .feedback-container {
        padding: 0;
    }
}
</style>



// WEBPACK FOOTER //
// resources/js/components/elements/FormOutPopup.vue